import type { ReactNode } from 'react';

import { ExclamationCircleIcon } from '../../../../icons';
import { t } from '../../../../index';

type Props = {
  message?: ReactNode;
};

export const ErrorElement = ({ message }: Props) => {
  return (
    <div className="flex gap-2 items-center p-lg bg-surface-error-secondary rounded-md">
      <ExclamationCircleIcon className="text-text-error" />
      <p className="flex-1 text-body-sm leading-lh-body-sm text-text-error">
        {message || t('pwa.network.server-error')}
      </p>
    </div>
  );
};
